package com.pincer.app.viewmodel

import com.pincer.app.ApplicationState
import com.pincer.app.I18n
import com.pincer.core.functions.readable
import com.pincer.core.functions.validateText
import com.pincer.core.functions.validatePrincipalName

fun summaries(state: ApplicationState, context: Node) {
    // Not everyone gets to see the summaries section.
    // There are three ways to get it:
    val noPincerLoaded = state.transient.pid == null
    val showAdvancedOptions = state.stored.showAdvancedOptions == "true"
    var isSeniorOnAtLeastOnePincer = false
    for (participation in state.personalPincer()!!.participations.values) {
        // For now we are working on the unbiquity of this particular token.
        // For a more general solution we would maybe need to test something like lifecycle scope?
        if (participation.includesRole("admin")) {
            isSeniorOnAtLeastOnePincer = true
            break
        }
    }
    if (!(noPincerLoaded || showAdvancedOptions || isSeniorOnAtLeastOnePincer)) return
    val count = state.personalPincer()!!.participations.size
    context.opening(state = state, key = "summaries", atFirst = noPincerLoaded, summary = I18n.translate(if (count == 1) "summaries-summary-one" else "summaries-summary", count.toString())) {
        for (entry in state.personalPincer()!!.participations) {
            val ppid = entry.key
            val participation = entry.value
            node(key = ppid, wording = participation.name ?: ppid) {
                if (!participation.summary.isNullOrEmpty()) {
                    node("summary", participation.summary!!)
                }
                if (ppid != state.transient.pid) {
                    button(key = "loadPincer", action = Action.LoadPincer(ppid))
                }
            }
        }
        node("newPincer") {
            val problem = validateText(state.transient.newPincerName)
            input(key = "setNewPincerName", action = Action.SetNewPincerName, wording = state.transient.newPincerName ?: "", problem = problem)
            possibleProblem(problem)
            button(key = "createNewPincer", action = Action.CreateNewPincer)
        }
    }
}